import Home from "./Home.svelte";
import Steam from "./Steam/Steam.svelte";
const routes = {
    '/': Home,
    '/steam': Steam,
};
export default routes;
